import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {SystemUser} from '../../../../shared/Models/SystemUser';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {EmailService} from '../../../Services/email.service';
import {LanguageService} from '../../../../translation/Services/language.service';
import {Email} from '../../../Models/Email';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-email-overview',
  templateUrl: './email-overview.component.html',
  styleUrls: ['./email-overview.component.scss']
})
export class EmailOverviewComponent implements OnInit {

  public grid: Grid;
  constructor(private router: Router, private translateService: TranslateService, private emailService: EmailService, private languageService: LanguageService) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.emails.subject',
          prop: 'subject',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.emails.event',
          prop: 'event',
          sortable: false,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.attributes.language',
          prop: 'language',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => row.name
        },
        <TextColumn>{
          name: 'doctrine.emails.status',
          prop: 'active',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            if (row) {
              return this.translateService.instant('global.active');
            }
            return this.translateService.instant('global.inactive');
          }
        },
        <TextColumn>{
          name: 'doctrine.emails.sendCopy',
          prop: 'hasCopy',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            if (row) {
              return this.translateService.instant('global.yes');
            }
            return this.translateService.instant('global.no');
          }
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/emails/' + row.id),
              showCallback: row => row,
              btnClass: 'ripple light'
            }
          ]
        }
      ],
      service: this.emailService,
      rememberURL: this.router.url,
      method: 'getEmails',
      defaultSort: 'subject',
      defaultSortType: 'desc',
      showButton: true,
      doseNotHaveSearch:true,
      search: [
        <GridSearchItem>{
          name: 'language_id',
          type: 'ng-select',
          label: 'doctrine.attributes.language',
          hasDropdownListFilter: true,
          hasNormalSearch:true,
          value: new ServiceSearchItem(this.languageService, 'list', {sortType: 'ASC', sortBy: 'name'}, (res) => {
            const options = [];
            for (const row of res.languages) {
              options.push({value: row.id, label: row.name});
            }
            return options;
          })
        },
      ],
    };
  }
}
